export default __webpack_public_path__ + "static/media/upload2.814b7e25.svg";